import React, { useEffect, useLayoutEffect } from "react";
import HomepageProduct from "./ProductComponent/HomepageProduct";
import HomepageFeature from "./FeatureComponent/HomepageFeature";
import HomepageTeam from "./TeamComponent/HomepageTeamNew";
import HomepageHeaderVideo from "./HeaderComponent/HomepageHeaderVideo";
import HomepageTestimonial from "./TestimonialComponent/HomePageTestimonial";
import HomepageNews from "./NewsComponent/HomepageNews";
import HomepageCustomers from "./CustomersComponent/HomepageCustomers";
import HomepageSupporters from "./SupportersComponent/HomepageSupporters";
import IntelligencePartner from "./PhysicalAI/IntelligencePartner";
import ScheduleDemo from "./ScheduleDemo/ScheduleDemo";
const Homepage = () => {
  useLayoutEffect(() => {
    // Scroll to top when component mounts - useLayoutEffect runs before paint
    // The scrollable container is the .main-content Box in App.js
    const scrollContainer = document.querySelector('.main-content');
    if (scrollContainer) {
      scrollContainer.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
    }
  }, []);
  
  useEffect(() => {
    // Also scroll after a brief delay to ensure it works
    const timer = setTimeout(() => {
      const scrollContainer = document.querySelector('.main-content');
      if (scrollContainer) {
        scrollContainer.scrollTo(0, 0);
      } else {
        window.scrollTo(0, 0);
      }
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  return (
    
    // <div className={classes.homepage}>
    <div height='50vh' overflow='auto' >
     
      <HomepageHeaderVideo />
      <HomepageProduct />
      <HomepageFeature />
      <HomepageCustomers />
      <HomepageTestimonial />
      <HomepageSupporters />
      <HomepageNews />
      <HomepageTeam />
      <IntelligencePartner />
      <ScheduleDemo />

    </div>
     
          
  );
};

export default Homepage;
